import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam } from '@hooks/params';

import { selectPersonalAccidentQuotePaymentPage } from './selector';
import {
  personalAccidentQuoteFetch,
  PersonalAccidentQuoteFetchPayload,
  billingFetch,
  BillingFetchPayload,
} from './action';

export const usePersonalAccidentQuoteFetch = () => {
  const orderNumber = useRouteParam('orderNumber') as string;
  const dispatch = useDispatch();
  const { personalAccidentQuote } = useSelector(selectPersonalAccidentQuotePaymentPage);
  useEffectOnce(() => {
    const payload: PersonalAccidentQuoteFetchPayload = { orderNumber };
    dispatch(personalAccidentQuoteFetch(payload));
  });
  return personalAccidentQuote;
};

export const useBillingFetch = () => {
  const dispatch = useDispatch();
  const billingId = Number(useRouteParam('billingId'));
  const { billing } = useSelector(selectPersonalAccidentQuotePaymentPage);
  useEffectOnce(() => {
    const payload: BillingFetchPayload = { id: billingId };
    dispatch(billingFetch(payload));
  });
  return billing;
};
